import { useMediaQuery } from '@mui/material';
import { IUserProfileData } from '../../createAndEdit/types';
import { formatRecipientLabel } from '../../utils';

interface IDetailInfoBarProps {
  userProfile?: IUserProfileData;
  origin?: string;
  originUserName?: string;
  recipient?: string;
}

const DetailInfoBar = (props: IDetailInfoBarProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const org = props.userProfile?.account || 'Concessionária';
  const senderName = props.originUserName;
  const originLabel = props.origin ? formatRecipientLabel(props.origin) : '';
  const recipientLabel = props.recipient ? formatRecipientLabel(props.recipient) : '';

  return (
    <div className={`${isMobile ? 'px-4' : 'px-6'} mb-2`}>
      <div className={`flex flex-col items-start gap-2 ${isMobile ? 'text-size-12' : 'text-size-14'}`}>
        <span className="font-family-sans-pro text-[#000000] dark:text-neutral-100 font-semibold" style={{ fontSize: '18px' }}>Enviado por</span>
        <div className={`flex mb-1 ${isMobile ? 'flex-col gap-1' : 'flex-row items-center gap-2'} font-bold ${isMobile ? 'text-size-14' : 'text-size-16'} text-[#344054] dark:text-neutral-200`}>
          {senderName && (
            <span className="text-gray-500 dark:text-neutral-400 text-size-14">{senderName}</span>
          )}
          {recipientLabel && (org || originLabel || senderName) && (
            <>
              <span className="text-gray-300 dark:text-neutral-600 text-size-16 mx-5">—</span>
              <span className="rioglyph rioglyph-user text-gray-500 dark:text-neutral-400 text-size-16 shrink-0" aria-hidden />
              <span className="text-gray-500 dark:text-neutral-400 text-size-14">{recipientLabel}</span>
            </>
          )}
        </div>
      </div>
      <div className="border-b border-gray-200 dark:border-neutral-700 mt-2" />
    </div>
  );
};

export default DetailInfoBar;
